import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import TagManager from 'react-gtm-module'

import { addLanguage } from './presentation/adapters/translate/translate'
import { GlobalStyle } from './presentation/styles/global'
import Routes from './presentation/components/routes'
import amplifyConfig from './main/configs/aws-exports.js'
import 'react-tooltip/dist/react-tooltip.css'

addLanguage('pt_BR')
Amplify.configure(amplifyConfig)

const tagManagerArgs = {
  gtmId: 'GTM-WV2LRQDH',
}

TagManager.initialize(tagManagerArgs)
declare global {
interface Window {
    dataLayer: any,
  }
}
const App = () => {
  window.dataLayer.push({
    event: 'appIndex',
  })

  return (
    <React.StrictMode>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        pauseOnHover={false}
      />
      <BrowserRouter>
        <GlobalStyle />
        <Routes />
      </BrowserRouter>
    </React.StrictMode>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
